import { lazy } from "react";

export { FORGOT_PASSWORD_PATH } from "./forgot-password-path";
export const ForgotPasswordPage = lazy(() => import("./forgot-password"));
